class PHProductOptions {

  constructor(root) {

    this.root = root;

    this.message =
      root.querySelector(
        "[data-ph-presentation-message]"
      );

    this.presentationGroup =

      [...root.querySelectorAll("[data-ph-option-name]")]

      .find((group) =>

        this.normalize(
          group.dataset.phOptionName
        ) === "presentacion"

      );

    if (
      !this.presentationGroup ||
      !this.message
    ) {
      return;
    }

    this.inputs =

      [...this.presentationGroup.querySelectorAll(
        'input[type="radio"]'
      )];

    this.select =
      this.presentationGroup.querySelector(
        "select"
      );

    this.bind();

    this.update();

  }

  normalize(value = "") {

    return value
      .toLowerCase()
      .normalize("NFD")
      .replace(
        /[\u0300-\u036f]/g,
        ""
      )
      .trim();

  }

  getSelectedValue() {

    if (this.select) {
      return this.select.value;
    }

    const selected =

      this.inputs.find(
        (input) => input.checked
      );

    return selected?.value || "";

  }

  getMessage(value) {

    const normalized =
      this.normalize(value);

    if (

      normalized.includes(
        "concentrado"
      ) &&

      (
        normalized.includes("feromona") ||
        normalized.includes("feromonas")
      )

    ) {

      return "👑 Mayor concentración de esencia más feromonas añadidas: nuestra opción más completa.";

    }

    if (
      normalized.includes(
        "concentrado"
      )
    ) {

      return "⭐ Mayor concentración de esencia para una presencia más intensa y prolongada.";

    }

    if (

      normalized.includes("feromona") ||
      normalized.includes("feromonas")

    ) {

      return "✨ Nuestra fórmula Regular con feromonas añadidas.";

    }

    return "🌿 Concentración equilibrada, ideal para el uso diario.";

  }
    bind() {

    this.root.addEventListener(

      "change",

      () => this.update()

    );

  }

  update() {

    const nextMessage =

      this.getMessage(

        this.getSelectedValue()

      );

    this.message.classList.add(

      "is-changing"

    );

    window.setTimeout(() => {

      this.message.textContent =

        nextMessage;

      this.message.classList.remove(

        "is-changing"

      );

    }, 120);

  }

}

const initPHProductOptions =

  (scope = document) => {

    scope

      .querySelectorAll(

        ".ph-variant-picker"

      )

      .forEach((root) => {

        if (

          root.dataset.phOptionsReady ===

          "true"

        ) {

          return;

        }

        root.dataset.phOptionsReady =

          "true";

        new PHProductOptions(

          root

        );

      });

};

document.addEventListener(

  "DOMContentLoaded",

  () =>

    initPHProductOptions()

);

document.addEventListener(

  "shopify:section:load",

  (event) =>

    initPHProductOptions(

      event.target

    )

);

if (
  typeof subscribe === "function" &&
  typeof PUB_SUB_EVENTS !== "undefined" &&
  PUB_SUB_EVENTS.variantChange
) {
  subscribe(
    PUB_SUB_EVENTS.variantChange,
    () => window.setTimeout(
      () => initPHProductOptions(),
      0
    )
  );
}

initPHProductOptions();
